import {
  Form,
  FormButton,
  SwitchInput,
  useNotifications
} from '@ijoin/components';
import {
  getGetPlanQueryKey,
  useGetPlanSuspense,
  usePatchPlan
} from '@ijoin/hooks';
import { Grid } from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';

import { FC } from 'react';
import { useForm } from 'react-hook-form';

type CoreCalcsFormProps = {
  useCoherentForMap: boolean;
  useCoherentForNonMap: boolean;
};

export const PlanCoreCalcsTab: FC<{ planId: string }> = props => {
  const queryClient = useQueryClient();
  const notifications = useNotifications();

  const plan = useGetPlanSuspense(props.planId);

  const methods = useForm<CoreCalcsFormProps>({
    mode: 'all',
    values: {
      useCoherentForMap: plan.data.useCoherentForMap ?? false,
      useCoherentForNonMap: plan.data.useCoherentForNonMap ?? false
    }
  });

  const patchPlan = usePatchPlan({
    mutation: {
      onError: () =>
        notifications.error('Failed to update core calcs settings'),
      onSuccess: () => {
        notifications.success('Core calcs settings updated successfully');
        queryClient.invalidateQueries({
          queryKey: getGetPlanQueryKey(props.planId)
        });
      }
    }
  });

  const onSubmit = (data: CoreCalcsFormProps) => {
    patchPlan.mutate({
      data: {
        useCoherentForMap: data.useCoherentForMap,
        useCoherentForNonMap: data.useCoherentForNonMap
      },
      planId: props.planId
    });
  };

  return (
    <Form
      data-testid='planCoreCalcsForm'
      methods={methods}
      noValidate
      onSubmit={methods.handleSubmit(onSubmit)}>
      <Grid container spacing={2} sx={{ pt: 4 }}>
        <Grid size={{ sm: 6, xs: 12 }}>
          <SwitchInput
            color='success'
            data-testid='useCoherentForMap'
            hideError
            label='Coherent based MAP Core Calcs'
            name='useCoherentForMap'
          />
        </Grid>
        <Grid size={{ sm: 6, xs: 12 }}>
          <SwitchInput
            color='success'
            data-testid='useCoherentForNonMap'
            hideError
            label='Coherent based Not in Managed Account Core Calcs'
            name='useCoherentForNonMap'
          />
        </Grid>
        <Grid size={12}>
          <FormButton
            data-testid='savePlanCoreCalcs'
            triggerValidation
            variant='contained'>
            Save
          </FormButton>
        </Grid>
      </Grid>
    </Form>
  );
};

PlanCoreCalcsTab.displayName = 'PlanCoreCalcsTab';
